module.exports = __webpack_public_path__ + "static/img/huaishuItem1.5f38d60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/huaishuItem1.png
// module id = VrEG
// module chunks = 0